<template>
    <div class="flex flex-col gap-8 justify-center items-center flex-1 h-full p-4">
        <div class="flex flex-col gap-4 justify-center items-center">
            <Mail :size="48" :class="stateColourMapClassForeground('warn')" />
            <p class="text-center">{{ $t('accountActivationRequiredPrompt') }}</p>
        </div>
        <Button
            :aria-label="$t('ariaLabel.backToLoginButton')"
            as="a"
            class="w-full md:w-auto"
            href="#login"
            severity="secondary"
            size="small"
            :label="$t('backToLogin')"
            variant="text" />
    </div>
</template>

<script lang="ts">
import { Mail } from 'lucide-vue-next';
import { classForeground as stateColourMapClassForeground } from '@modules/state-colour-map';

export default {
    components: {
        Mail
    },
    methods: {
        stateColourMapClassForeground: stateColourMapClassForeground
    }
};
</script>
